import * as React from 'react'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
import './styles.scss'

interface Props {
    income: number,
    spent: number,
    default: number,
    showGhost: boolean,
    onSlideEnd: (value: number[]) => void
}

const sliderStyle = {
    position: 'relative',
    userSelect: 'none',
    width: '100%',
    height: 80,
  }
  
  const railStyle = { 
    position: 'absolute',
    width: '100%',
    height: 80,
    borderRadius: 1,
    backgroundColor: '#ad427f',
  }

  function Handle({
    position,
    handles,
    handle: { id, value, percent }, 
    getHandleProps
  }) {
    return (
      <div
        className={'sliderHandleCatcher'}
        style={{left: `${percent}%`}}
        {...getHandleProps(id)}
      >
        <div className={'sliderHandle'}>
          <div className={'sliderHandleValue'}>
            <svg>
              <text x={position == 'left' ? '0px' : '100%'} y="68%">{handles[2].value - handles[1].value} CHF</text>
            </svg>
          </div>
        </div>
      </div>
    )
}

function SpentTrack({ source, target, getTrackProps }) {
    return (
      <div
        style={{
          position: 'absolute',
          height: 80,
          zIndex: 1,
          backgroundColor: '#f5f6f7',
          background:'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAK0lEQVQoU2P8+u37fwY8gJEsBTt8Ohg8tlSAzSXPBGQnEWcCsp3oHiJoAgBxTCURuzvwmQAAAABJRU5ErkJggg==)',
          borderRadius: 0,
          cursor: 'pointer',
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
      />
    )
}

function Track({ source, target, getTrackProps }) {
    return (
      <div
        style={{
          position: 'absolute',
          height: 80,
          zIndex: 1,
          backgroundSize: '5.66px 5.66px',
          backgroundImage: 'linear-gradient(135deg, #a51285 12.50%, #ffffff 12.50%, #ffffff 50%, #a51285 50%, #a51285 62.50%, #ffffff 62.50%, #ffffff 100%)',
          borderRadius: 0,
          cursor: 'pointer',
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
      >
        <div className='sliderTooltip'>
            <img style={{width: '25px'}} src={require('./arrow.svg')} />
            <div>Estimez un montant</div>
        </div>
      </div>
    )
}

export default class MoneySlider extends React.Component<Props, any> {
    public constructor(props):void {
        super(props)
        this.setTooltipPosition = this.setTooltipPosition.bind(this)
        this.state = {
            value: this.props.default,
            handleGhost: this.props.showGhost
        }
    }

    private getClasses() {
      let classesString = ''
      if(this.state.handleGhost) classesString += 'showGhost '
      if(this.state.handlePosition == 'left'){
        classesString += 'left'
      } else {
        classesString += 'right'
      }
      return classesString
    }

    public componentDidMount() {
    }

    private setTooltipPosition(value) {
        if(this.props.income / value > 2) {
          this.setState({handlePosition: 'left'})
        } else {
          this.setState({handlePosition: 'right'})
        }
    }

    public render() {
        return (
            <div style={{marginTop: '1em'}} className={this.getClasses()}>
                <Slider
                    rootStyle={sliderStyle}
                    domain={[0, this.props.income]}
                    values={[0, this.props.spent, this.props.spent + this.state.value]}
                    mode={2}
                    step={1}
                    onUpdate={(value: number[]) => {
                      this.setTooltipPosition(value[2])
                    }}
                    onSlideStart={() => {
                      // Hide handle ghost
                      if(this.state.handleGhost) {
                        this.setState({
                            handleGhost: false
                        })
                      }
                    }}
                    onSlideEnd={(value: number[]) => {
                      this.props.onSlideEnd(value)
                      this.setState({value: value[2] - value[1]})
                    }}
                >
                    <div style={railStyle} />
                    <Rail>
                    {({ getRailProps }) => (
                        <div style={railStyle} {...getRailProps()} /> 
                    )}
                    </Rail>
                    <Handles>
                    {({ handles, getHandleProps }) => (
                        <div className="slider-handles">
                            <Handle
                                position={this.state.handlePosition}
                                handles={handles}
                                key={handles[2].id}
                                handle={handles[2]}
                                getHandleProps={getHandleProps}
                            />
                        </div>
                    )}
                    </Handles>
                    <Tracks left={false} right={false}>
                    {({ tracks, getTrackProps }) => (
                        <div className="slider-tracks">
                            <SpentTrack
                            key={0}
                            source={tracks[0].source}
                            target={tracks[0].target}
                            getTrackProps={() => {}}
                            />
                            <Track
                            key={1}
                            source={tracks[1].source}
                            target={tracks[1].target}
                            getTrackProps={() => {}}
                            />
                        </div>
                    )}
                    </Tracks>
                </Slider>
            </div>
        )
    }
}